import React from "react";

export interface SelectTokensButtonProps {
  visible: boolean;
  numberOfTokens: number;
  onClick: () => void;
}

export const SelectTokensButton: React.FC<SelectTokensButtonProps> = ({
  visible,
  numberOfTokens,
  onClick,
}) => {
  if (!visible) {
    return null;
  }

  return (
    <>
      <div
        className="d-flex flex-column"
        style={{
          padding: "17px",
          borderTop: "1px solid #667474",
        }}
      >
        <input
          data-testid={"modal-select-tokens-btn"}
          type="submit"
          value={`Select ${numberOfTokens > 1 ? `${numberOfTokens} ` : ""}Token${
            numberOfTokens > 1 ? "s" : ""
          }`}
          className={`btn-bebop-primary text-white`}
          onClick={() => onClick()}
        />
      </div>
    </>
  );
};
